//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { addCourse, getTeacher, updateCourse, getCourse } from '@/api/curriculm'
// import { getToken } from '@/utils/auth'
// import { getStyle } from '@/api/style'
// import axios from 'axios'
import { cateInfo_list, authorInfo_list, updateBook, searchCate, searchAuthor } from '@/api/books';
export default {
  name: 'child',
  data: function data() {
    return {
      url_upload: process.env.VUE_APP_BASE_API,
      // token: getToken(),
      imageUrl: '',
      tabMapOptions: [],
      teacherOptions: [],
      dialogStatus: '',
      textMap: {
        update: 'Edit',
        create: 'Create'
      },
      dialogPvVisible: false,
      pvData: [],
      rules: {
        name: [{
          required: true,
          message: '名称不能为空',
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: '简介不能为空',
          trigger: 'blur'
        }],
        describetion: [{
          required: true,
          message: '描述不能为空',
          trigger: 'blur'
        }],
        style_id: [{
          required: true,
          message: '请选择命格',
          trigger: 'change'
        }],
        teacher_id: [{
          required: true,
          message: '请选择老师',
          trigger: 'change'
        }]
      },
      downloadLoading: false,
      temp: {
        bookname: '',
        // 作品名称
        id: 0,
        cate: '',
        // 分类
        author: '',
        // 作者
        cover: '',
        // 封面图链接
        descrition: '',
        // 作品描述
        sex: 1 // 性别

      },
      Classify: [],
      // 分类列表
      AuthorList: [],
      // 作者列表
      fenlei: '',
      // 输入分类
      zuozhe: '' // 输入作者

    };
  },
  created: function created() {
    this.GetClassify();
    this.GetAuthor();
    var row = this.$route.query.row;

    if (row) {
      row = JSON.parse(row);
      console.log(row);
      this.temp.bookname = row.bookname;
      this.temp.id = row.id;
      this.temp.cate = row.cate;
      this.temp.author = row.author;
      this.temp.cover = row.cover;
      this.temp.descrition = row.description;
      this.temp.dialogStatus = 'update';
    } else {
      this.temp.id = this.$route.query.id;
      this.temp.id = this.id;
      this.dialogStatus = 'create';
    }
  },
  methods: {
    // 分类输入搜索
    gaibian: function gaibian() {
      var _this = this;

      console.log(this.fenlei);
      var catename = this.fenlei;
      searchCate({
        catename: catename
      }).then(function (res) {
        console.log(res);
        _this.Classify = res.data;
      });
    },
    // 作者输入搜索
    seek: function seek() {
      var _this2 = this;

      var authorname = this.zuozhe;
      searchAuthor({
        authorname: authorname
      }).then(function (res) {
        console.log(res);
        _this2.AuthorList = res.data;
      });
    },
    // 获取分类
    GetClassify: function GetClassify() {
      var _this3 = this;

      cateInfo_list().then(function (res) {
        console.log(res);
        _this3.Classify = res.data;
      });
    },
    // 获取作者
    GetAuthor: function GetAuthor() {
      var _this4 = this;

      authorInfo_list().then(function (res) {
        console.log(res);
        _this4.AuthorList = res.data;
      });
    },
    GetCourse: function GetCourse(id) {
      var _this5 = this;

      getCourse(id).then(function (resp) {
        _this5.temp = resp.course;
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    createData: function createData() {
      var _this6 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this6.temp.style_id == '八字') {
            _this6.temp.style_id = 1;
          } else if (_this6.temp.style_id == '紫薇') {
            _this6.temp.style_id = 2;
          } else if (_this6.temp.style_id == '六爻') {
            _this6.temp.style_id = 3;
          }

          addCourse(_this6.temp).then(function (response) {
            console.log(_this6.temp);

            _this6.$nextTick(function () {
              if (_this6.temp.free == 1) {
                _this6.temp.price = '0';
              }

              if (response.code == 0) {
                _this6.$notify({
                  title: '成功',
                  message: '创建成功',
                  type: 'success',
                  duration: 2000
                });

                _this6.imageUrl = ''; //跳转到上一次浏览的页面  this.$router.go(-1)

                _this6.$router.go(-1);
              } else if (response.code == 1) {
                _this6.$notify({
                  title: '失败',
                  message: '创建失败',
                  type: 'error',
                  duration: 2000
                });

                _this6.imageUrl = '';
              }
            });
          });
        }
      });
    },
    // 编辑
    updateData: function updateData() {
      var _this7 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          // const tempData = Object.assign({}, this.temp)
          var temp = _this7.temp;
          console.log(temp);
          updateBook(temp).then(function (response) {
            console.log(response);

            _this7.$nextTick(function () {
              if (response.code == 0) {
                _this7.$notify({
                  title: '成功',
                  message: '更新成功',
                  type: 'success',
                  duration: 2000
                });
              } else {
                _this7.$notify({
                  title: '失败',
                  message: '更新失败',
                  type: 'error',
                  duration: 2000
                });
              }
            }); //跳转到上一次浏览的页面  this.$router.go(-1)


            _this7.$router.go(-1);
          });
        }
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw); //上传成功

      this.temp.cover = res.url;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      console.log(file, 6666666);
      var isJPG = file.type;
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (isJPG != 'image/jpeg' && isJPG != 'image/png' && isJPG != 'image/gif' && isJPG != 'image/jpg' && isJPG != 'image/svg') {
        this.$message.error('图片格式不允许');
      }

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }

      return isJPG && isLt2M;
    }
  }
};